import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';

import styles from './StatusBar.module.scss';

const StatusBar = (props) => {
  const { statuses } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.statusBar}>
      {statuses.map((status, i) => {
        const isActive = Boolean(status.date);
        const isLast = i === statuses.length - 1;

        return (
          <div
            key={status.text}
            className={cs({
              [styles.statusWrapper]: true,
              [styles.active]: isActive,
              [styles.first]: i === 0,
            })}
          >
            <div className={styles.statusDetails}>
              <div>{t(`claim.invoiceStatus.${status.text}`)}</div>
            </div>
            <div className={styles.statusState}>
              <div className={styles.statusCircle}>{isActive && <Icon name="check" />}</div>
              {isLast ? null : <div className={styles.contentBefore} />}
            </div>
            <div className={styles.dateDetails}>
              <div>{status.date}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

StatusBar.propTypes = {
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default StatusBar;
